function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcancelPage = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.97659L21.742 7.99859H18.714C18.32 7.99859 18 7.61759 18 7.14859V3.97659ZM23.741 7.328L19.296 2.328C19.107 2.119 18.838 2 18.556 2H10.556C9.146 2 8 3.122 8 4.5V19.5C8 20.878 9.146 22 10.556 22H21.444C22.854 22 24 20.878 24 19.5V8C24 7.751 23.908 7.512 23.741 7.328Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "17",
    r: "8",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7068 18.2931C11.0977 18.6841 11.0977 19.316 10.7068 19.707C10.5118 19.902 10.2558 20 9.99983 20C9.74385 20 9.48788 19.902 9.29289 19.707L8 18.4141L6.70711 19.707C6.51212 19.902 6.25615 20 6.00017 20C5.74419 20 5.48821 19.902 5.29323 19.707C4.90226 19.316 4.90226 18.6841 5.29323 18.2931L6.58612 17.0001L5.29323 15.7072C4.90226 15.3162 4.90226 14.6842 5.29323 14.2932C5.68419 13.9023 6.31614 13.9023 6.70711 14.2932L8 15.5862L9.29289 14.2932C9.68386 13.9023 10.3158 13.9023 10.7068 14.2932C11.0977 14.6842 11.0977 15.3162 10.7068 15.7072L9.41388 17.0001L10.7068 18.2931ZM8 11C4.6916 11 2 13.6916 2 17C2 20.3084 4.6916 23 8 23C11.3084 23 14 20.3084 14 17C14 13.6916 11.3084 11 8 11Z",
    fill: "#495057"
  }));
});